import { render, staticRenderFns } from "./TxProductSettingsPortal.vue?vue&type=template&id=366c9419&scoped=true&"
import script from "./TxProductSettingsPortal.vue?vue&type=script&lang=js&"
export * from "./TxProductSettingsPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c9419",
  null
  
)

export default component.exports